import React from 'react';
import Icon from '@/components/ui/AppIcon';

interface MissionSectionProps {
  className?: string;
}

interface ValueItem {
  id: number;
  icon: string;
  title: string;
  description: string;
}

const MissionSection = ({ className = '' }: MissionSectionProps) => {
  const values: ValueItem[] = [
    {
      id: 1,
      icon: 'UserGroupIcon',
      title: 'People-First Approach',
      description: 'We believe AI success is a leadership problem, not a technology problem. Our methodology centers on empowering people to drive sustainable change.',
    },
    {
      id: 2,
      icon: 'LightBulbIcon',
      title: 'Practical Wisdom',
      description: 'We focus on execution over theory, delivering proven frameworks that bridge the gap between AI investment and measurable business outcomes.',
    },
    {
      id: 3,
      icon: 'ShieldCheckIcon',
      title: 'Trusted Partnership',
      description: 'We operate as a curated professional alliance, combining enterprise-grade expertise with collaborative delivery models that ensure quality.',
    },
    {
      id: 4,
      icon: 'ChartBarIcon',
      title: 'Measurable Impact',
      description: 'Every engagement is designed to deliver tangible results through capability building, risk mitigation, and sustainable organizational transformation.',
    },
  ];

  return (
    <section className={`py-16 lg:py-24 bg-background ${className}`}>
      <div className="container mx-auto px-4">
        <div className="max-w-3xl mx-auto text-center mb-16">
          <h2 className="text-3xl md:text-4xl lg:text-5xl font-bold font-headline text-primary mb-6">
            Our Mission & Values
          </h2>
          <p className="text-lg text-muted-foreground font-body leading-relaxed">
            We exist to make AI transformations succeed by addressing the critical gap between technology investment and organizational adoption. Our mission is to empower leaders with the frameworks, expertise, and support needed to drive human-centered AI change.
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-8 max-w-6xl mx-auto">
          {values.map((value) => (
            <div
              key={value.id}
              className="bg-card rounded-lg p-8 shadow-card hover:shadow-strong transition-all duration-300 border border-border"
            >
              <div className="flex items-start space-x-4">
                <div className="flex-shrink-0">
                  <div className="w-12 h-12 rounded-lg bg-secondary/10 flex items-center justify-center">
                    <Icon name={value.icon as any} size={24} className="text-secondary" variant="solid" />
                  </div>
                </div>
                <div className="flex-1">
                  <h3 className="text-xl font-semibold font-headline text-foreground mb-3">
                    {value.title}
                  </h3>
                  <p className="text-muted-foreground font-body leading-relaxed">
                    {value.description}
                  </p>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default MissionSection;